import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var dropdownContentScrollAreaViewport = 'fx_2d2fb1e5_4rg3uc9';
var dropdownContentVariants = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_4rg3uc3',variantClassNames:{fitToTrigger:{true:'fx_2d2fb1e5_4rg3uc4',false:'fx_2d2fb1e5_4rg3uc5'},prefersReducedMotion:{reduce:'fx_2d2fb1e5_4rg3uc6',noPreference:'fx_2d2fb1e5_4rg3uc7'}},defaultVariants:{fitToTrigger:false,prefersReducedMotion:'noPreference'},compoundVariants:[]});

export { dropdownContentScrollAreaViewport, dropdownContentVariants };
//# sourceMappingURL=content.vanilla.mjs.map
